import React from 'react'

import { Fieldset, Icon, RadioButton } from '@fourthwall/components'
import { ExclamationMarkIcon } from '@fourthwall/icons'

import * as S from './ManufacturingServiceSelect.styled'
import type { Props, RadioItem } from './types'

const ITEMS: RadioItem[] = [
  {
    manufacturingService: 'FOURTHWALL_BESPOKE',
    label: 'Fourthwall Bespoke',
  },
  {
    manufacturingService: 'MANUFACTURED_BY_CREATOR',
    label: 'Creator Manufactured',
    rightContent: <Icon component={ExclamationMarkIcon} height={24} />,
  },
]

export const ManufacturingServiceSelect = ({ selectedManufacturingService, onSelect }: Props) => {
  return (
    <Fieldset>
      {ITEMS.map(({ label, manufacturingService, rightContent }) => (
        <Fieldset.Row key={manufacturingService}>
          <RadioButton
            name={manufacturingService}
            value={manufacturingService}
            label={label}
            onChange={() => onSelect(manufacturingService)}
            checkedValue={selectedManufacturingService}
          />
          {rightContent && (
            <S.ItemRightContentContainer>{rightContent}</S.ItemRightContentContainer>
          )}
        </Fieldset.Row>
      ))}
    </Fieldset>
  )
}
